// eslint-disable-next-line no-restricted-syntax
export enum ExtraWorkedTimeRequestLiterals {
  TYPE = "ExtraWorkedTimeRequest",
}

// eslint-disable-next-line no-restricted-syntax
export enum ExtraWorkedTimeType {
  BREAK = "BREAK",
}

// eslint-disable-next-line no-restricted-syntax
export enum ExtraWorkedTimeRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  FAILED = "FAILED",
}

// eslint-disable-next-line no-restricted-syntax
export enum ExtraWorkedTimeRequestStatusUpdater {
  SYSTEM = "SYSTEM",
  FACILITY_USER = "FACILITY_USER",
  CBH_AGENT = "CBH_AGENT",
}

// eslint-disable-next-line no-restricted-syntax
export enum ExtraWorkedTimeRequestPayer {
  CBH = "CBH",
  HCF = "HCF",
}

// eslint-disable-next-line no-restricted-syntax
export enum IncludedForExtraWorkedTimeRequestType {
  SHIFT = "shift",
  FACILITY_PROFILE = "facilityProfile",
  FACILITY_USER = "facilityUser",
}

export interface ExtraWorkedTimeRequest {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _id: string;
  type: ExtraWorkedTimeType;
  reason: string;
  start: string;
  end: string;
  status: ExtraWorkedTimeRequestStatus;
  createdAt: string;
  billedTo?: ExtraWorkedTimeRequestPayer;

  // eslint-disable-next-line @typescript-eslint/ban-types
  statusUpdatedBy?: ExtraWorkedTimeRequestStatusUpdater | null;
  statusUpdatedById?: string;
  statusUpdateReason?: string;
  updatedAt?: string;
}
